export default __webpack_public_path__ + "static/miniboo-65f5938d69bc812a88633ce14e94d4a3.ico";